var map = {
	"./base": 321,
	"./base.js": 321,
	"./home": 500,
	"./home/": 500,
	"./home/base": 501,
	"./home/base.js": 501,
	"./home/index": 500,
	"./home/index.js": 500,
	"./pages": 499,
	"./pages/": 499,
	"./pages/base": 505,
	"./pages/base.js": 505,
	"./pages/index": 499,
	"./pages/index.js": 499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;